import { EMOJI_TYPE } from './../../ricos-content';
import { Node_Type } from './../../ricos-types';

export const TRANSACTION_META_KEYS = {
  EDITING_CELL: 'editing-cell',
  SELECTED_CELL: 'selected-cell',
  SELECT_COLUMN: 'select-column',
  SELECT_ROW: 'select-row',
};

export const supportedPluginTypes = [
  `${Node_Type.AUDIO}.audio`,
  `${Node_Type.AUDIO}.soundCloud`,
  `${Node_Type.AUDIO}.spotify`,
  Node_Type.FILE,
  Node_Type.IMAGE,
  `${Node_Type.VIDEO}.video`,
  `${Node_Type.VIDEO}.youTube`,
  Node_Type.GIF,
  Node_Type.DIVIDER,
  EMOJI_TYPE,
  Node_Type.CODE_BLOCK,
];
